import Axios from 'axios';
export const baseApi = Axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	withCredentials: true,
});

// baseApi.interceptors.request.use(
//   (config) => {
//     // get token from query and pass it to the header authorization
//     if (typeof window !== "undefined") {
//       const search = window.location.search;
//       const params = new URLSearchParams(search);
//       const token = params.get("token");
//       if (token) {
//         config.headers.Authorization = `${token}`;
//       }
//     }
//     return config;
//   },
//   (error) => {
//     // If there's an error, reject the Promise with the error
//     return Promise.reject(error);
//   }
// );

// @Author
// https://kentcdodds.com/blog/get-a-catch-block-error-message-with-typescript


type ErrorWithMessage = {
	message: string;
};

function isErrorWithMessage(error: unknown): error is ErrorWithMessage {
	return typeof error === 'object' && error !== null && 'message' in error && typeof (error as Record<string, unknown>).message === 'string';
}

export function toErrorWithMessage(maybeError: unknown): ErrorWithMessage {
	if (isErrorWithMessage(maybeError)) return maybeError;

	try {
		return new Error(JSON.stringify(maybeError));
	} catch {
		// fallback in case there's an error stringifying the maybeError
		// like with circular references for example.
		return new Error(String(maybeError));
	}
}

export function getErrorMessage(error: unknown) {
	return toErrorWithMessage(error).message;
}

export function axiosErrorHandler(error: unknown) {
	if (Axios.isAxiosError(error)) {
		if (error.response?.data) {
			return error.response.data as { message: string } | { detail: { loc: string[] }; msg: string; type: string }[];
		}
	} else {
		return {
			message: getErrorMessage(error),
		};
	}
}
